// EP-160 T160-104l (S6): the tenant's My data page (EN).
// A privacy notice, not a consent: the header names the operator as controller
// and FlowRent as processor. "Consent" appears only for the withdrawal request
// type, which is about the rewards identity (EP-160 2.7).
export default {
  title: 'My data',
  home_row_title: 'My data',
  home_row_subtitle: 'Ask for a copy of your personal data, or to delete or correct it',
  controller: '{{name}} is the controller of your personal data',
  contact: 'Contact: {{contact}}',
  processor: '{{processor}} is the processor',
  policy_link: '{{processor}} privacy policy ›',
  access_button: 'Request a copy of my data',
  access_hint: 'Download link within 30 days',
  erasure_button: 'Ask to delete my data',
  erasure_hint: 'The building owner approves it',
  erasure_confirm_title: 'Ask to delete my data',
  erasure_confirm_body:
    'The building owner will decide within 30 days. Once approved, your personal data is deleted; invoices and payments are kept, without your name.',
  erasure_confirm_submit: 'Send request',
  other_button: 'Other request (correct / restrict / object / withdraw consent)',
  other_title: 'Other request',
  other_type_label: 'Request type',
  other_note_label: 'Details',
  other_note_placeholder: 'Tell the building owner what you need',
  other_note_required: 'Please add the details',
  other_note_optional: 'Optional',
  other_submit: 'Send request',
  types: {
    access: 'Copy of data',
    erasure: 'Delete data',
    rectification: 'Correct data',
    restriction: 'Restrict use',
    objection: 'Object to use',
    withdrawal: 'Withdraw consent',
  },
  statuses: {
    pending: 'Pending',
    processing: 'In progress',
    completed: 'Done',
    rejected: 'Rejected',
  },
  requests_title: 'Requests',
  requests_empty: 'No requests yet',
  sent: 'Request sent. The building owner will reply within 30 days.',
  export_ready: 'Link ready ›',
  restriction_lifted: 'Restriction lifted on {{date}}',
  export_expired: 'The link has expired, you can ask again',
  export_not_ready: 'The link is not ready yet',
  error: 'Something went wrong. Please try again.',
}
